import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const BarContainer = styled.div`
  margin: 1px 0;
  overflow-y: visible;
`;

const Label = styled.div`
  font-size: 16px;
  margin-bottom: 1px;
`;

const Bar = styled.div`
  background: #e0e0e0;
  border-radius: 10px;
`;

const Progress = styled.div`
  background: #0f172a;
  height: 6px;
  width: ${props => props.percentage}%;
  max-width: 100%;
  transition: width 1s ease-in-out;
  border-radius: 10px 0 0 10px;
`;

const SkillBar = ({ skill, percentage }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(percentage);
  }, [percentage]);

  return (
    <BarContainer>
      <Label>{skill}</Label>
      <Bar>
        <Progress percentage={progress} />
      </Bar>
    </BarContainer>
  );
};

export default SkillBar;
